import { render, staticRenderFns } from "./SeriesPreviewQuestionPluginWordsCompletion.vue?vue&type=template&id=0d8cee7a&"
import script from "./SeriesPreviewQuestionPluginWordsCompletion.vue?vue&type=script&lang=js&"
export * from "./SeriesPreviewQuestionPluginWordsCompletion.vue?vue&type=script&lang=js&"
import style0 from "./SeriesPreviewQuestionPluginWordsCompletion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports